<template>
  <div class="myHome">
    <div class="zf" v-if="abox == false">
      <div class="back" @click="backorder()">返回</div>
      <div id="loc" ref="qrcode" class="rwm"></div>
      <div class="wphtitle" v-if="letc === '1'">微信支付</div>
      <div class="Yz" v-if="letc === '1'">
        {{ wxdata.icon }}{{ Number(wxdata.total_fee).toFixed(2) }}
      </div>
      <div class="jydh" v-if="letc === '1'">
        交易单号：{{ wxdata.out_trade_no }}
      </div>
    </div>
  </div>
</template>

<script>
import Qrcode from 'qrcodejs2'
import { settoken } from '@/utils/auth'
import { placeAnOrder, checkPay, appcheckPay,cateringOrderPlaceAnOrder,cateringOrderCheck, payPhoneRechargeConsume } from '@/API/user'
import utils from '@/utils/utils.js'

export default {
  name: 'myHome',
  data () {
    return {
      wxdata: {},
      letc: '',
      order_no: '',
      query: {},
      abox:true
    }
  },
  created () {
    console.log('进入当前页面', location)
    const params = {}
    // 替换&amp;为&
    if (location.href.indexOf('&amp%3B') != -1) {
      const decodedUrl = location.href.replace(/&amp%3B/g, '&')
      const urlObj = new URL(decodedUrl)

      urlObj.searchParams.forEach((value, key) => {
        if (key !== 'kbz_url') {
          params[key] = value
        }
      })
    } else {
      if (location.href.indexOf('source') != -1) {
        // 匹配kbz_url参数值
        const kbzUrlMatch = location.href.match(/kbz_url=([^&]+)/)
        if (kbzUrlMatch) {
          // 获取kbz_url值
          const kbzUrl = kbzUrlMatch[1]

          // 添加到参数对象
          params['kbz_url'] = kbzUrl
        }

        // 解析其他参数使用URL对象
        const urlObj = new URL(location.href)
        urlObj.searchParams.forEach((value, key) => {
          if (key !== 'kbz_url') {
            params[key] = value
          }
        })
      }

      console.log('tag', params, encodeURI(this.$route.query.kbz_url))
    }

    if (this.$route.query.source == 'app') {
      console.log(params)
      this.order_no = params.order_sn
      localStorage.setItem('query', JSON.stringify(params))
      let key = '9bwht7zb5rmhv5ygmbicbz8vbmhnvp'
      top.location.href = encodeURI(this.$route.query.kbz_url)
      let headers = utils.getsign(
        {
          order_no: this.order_no
        },
        key
      )
      this.timer = setInterval(async () => {
        let data = await appcheckPay({
          order_no: this.order_no,
          sign: headers['x-sign']
        })
        if (data.error === 0) {
          console.log(data, this.$route.query)
          if (params.merchant_url.indexOf('?order_id=') != -1) {
            top.location.href = encodeURI(
              params.merchant_url + params?.order_no
                ? '&order_no=' + params.order_no
                : ''
            )
          } else {
            top.location.href = encodeURI(params.merchant_url)
          }
        }
      }, 4000)
    } else if (this.$route.query.source == 'zhichong') {
      this.order_no = params.order_sn
      localStorage.setItem('ZCquery', JSON.stringify(params))
      // let key = '9bwht7zb5rmhv5ygmbicbz8vbmhnvp'
      top.location.href = encodeURI(this.$route.query.kbz_url)
    } else {
      if (this.$route.query.a) {
        let a = JSON.parse(this.$route.query.a)
        // 话费充值：独立分流，避免走原商城微信分支
        if (a && a.bizType === 'phoneRecharge') {
          this.creadersize()
          this.creaderdata()
          return
        }
        console.log(a, '找找isWx')
        console.log(a.isWx, '找找a.isWx')
        if (a.isWx) {
          // 调用微信的jsapi支付
          let data = a.data

          if(a.isXcx){
            wx.config({
              debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: data.appId, // 必填，公众号的唯一标识
              timestamp:data.timeStamp , // 必填，生成签名的时间戳
              nonceStr: data.nonceStr, // 必填，生成签名的随机串
              signature: data.paySign,// 必填，签名
              jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表
            });
            wx.ready(function(){
              wx.chooseWXPay({
                timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
                package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: data.paySign, // 支付签名

              });
              // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。

            })
          }else {
            // // 检测支付环境中的 WeixinJSBridge
            setTimeout(() => {
              // alert(typeof window.WeixinJSBridge == 'undefined')
              if (typeof window.WeixinJSBridge == 'undefined') {
                if (document.addEventListener) {
                  console.log('来了1')
                  document.addEventListener(
                      'WeixinJSBridgeReady',
                      this.onBridgeReady(data),
                      false
                  )
                } else if (document.attachEvent) {
                  console.log('来了2')
                  document.attachEvent(
                      'WeixinJSBridgeReady',
                      this.onBridgeReady(data)
                  )
                  document.attachEvent(
                      'onWeixinJSBridgeReady',
                      this.onBridgeReady(data)
                  )
                }
              } else {
                console.log('WeixinJSBridge失败')
                this.onBridgeReady(data)
              }
            }, 1000)
          }
        } else {
          this.creadersize()
          this.creaderdata()
        }
        console.log(this.$route.query.a, '执行')
      } else {
        console.log(localStorage.getItem('query'))
        if (localStorage.getItem('query')) {
          console.log('1')
          this.query = JSON.parse(localStorage.getItem('query'))
          this.order_no = this.query.order_sn
          localStorage.removeItem('query')
          let key = '9bwht7zb5rmhv5ygmbicbz8vbmhnvp'
          let headers = utils.getsign(
            {
              order_no: this.order_no
            },
            key
          )
          this.timer = setInterval(async () => {
            let data = await appcheckPay({
              order_no: this.order_no,
              sign: headers['x-sign']
            })
            if (data.error === 0) {
              console.log(data, this.$route.query)
              top.location.href = encodeURI(
                this.query.merchant_url + this.query?.order_no
                  ? this.query.order_no
                  : ''
              )
            }
          }, 4000)
        } else {
          console.log('2')
          let url =
            localStorage.getItem('returnAddress') +
            'usermy/myOorder?storeId=' +
            localStorage.getItem('storeID')
          location.href = encodeURI(url)
        }
      }
    }
  },
  mounted () {
    this.domain = window.location.hostname + '/submitAfterapp'
    document.addEventListener('visibilitychange', this.is_Visible)
  },
  destroyed () {
    document.removeEventListener('visibilitychange', this.is_Visible)
  },
  methods: {
    onBridgeReady (data) {
      let a = JSON.parse(this.$route.query.a)
      console.log('进来了11111', data)
      let wxCofing=data.result?JSON.parse(data.result):data
      let params = {
        debug: true,
        appId: wxCofing.appId, //公众号ID，由商户传入
        timeStamp: wxCofing.timeStamp.toString(), //时间戳，自1970年以来的秒数
        nonceStr: wxCofing.nonceStr, //随机串
        package: wxCofing.package,
        signType: wxCofing.signType, //微信签名方式：
        paySign: wxCofing.paySign //微信签名
      }
      window.WeixinJSBridge.invoke('getBrandWCPayRequest', params, function (res) {
        if (a && a.bizType === 'phoneRecharge') {
          const base = String(a.returnAddress || '').trim()
          if (base) {
            location.href = encodeURI(base)
          } else {
            // location.href = encodeURI('/s/phoneBill/orderList')
          }
          return
        }
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          console.log('pay success')
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          let url=''
          if(a.foodOrder){
            url = a.returnAddress + 'orderFood?storeId=' + a.storeId
          }else{
             url = a.returnAddress + 'usermy/myOorder?storeId=' + a.storeId
          }
          location.href = encodeURI(url)
        } else {
          let url=''
          if(a.foodOrder){
            url = a.returnAddress + 'orderFood?storeId=' + a.storeId
          }else{
             url = a.returnAddress + 'usermy/myOorder?storeId=' + a.storeId
          }
          location.href = encodeURI(url)
          console.log(res.err_msg)
        }
      })
    },
    is_Visible: function (e) {
      if (!this.$route.query.source) {
        if (this.$route.query.a) {
          this.creadersize()
          let a = JSON.parse(this.$route.query.a)
          console.log('执行这里吗？', e.target.visibilityState)
          if (this.abox === true) {
            if (e.target.visibilityState === 'visible') {
              if(a.foodOrder){
                
                // let url = a.returnAddress + 'orderFood?storeId=' + a.storeId
                // location.href = encodeURI(url)
              }else if (a.type === '1') {
                let b = {
                  type: '1',
                  orderNo: a.orderNo,
                  payeeSettingId: a.payeeSettingId,
                  userId: a.userId,
                  storeId: a.storeId
                }
                let url = a.returnAddress + 'usermy/myOorder?storeId=' + a.storeId+'&b='+JSON.stringify(b)
                location.href = encodeURI(url)
              }else if (a.type === 2) {
                let b = {
                  type: '0',
                  orderNo: a.orderNo,
                  payeeSettingId: a.payeeSettingId,
                  userId: a.userId,
                  storeId: a.storeId
                }
                let url = a.returnAddress + 'usermy/myOorder?storeId=' + a.storeId+'&b='+JSON.stringify(b)
                location.href = encodeURI(url)
              }else if (a.type === '6') {
                let b = {
                  type: '4',
                  orderNo: a.orderNo,
                  payeeSettingId: a.payeeSettingId,
                  userId: a.userId,
                  storeId: a.storeId
                }
                let url = a.returnAddress + 'usermy/myOorder?storeId=' + a.storeId+'&b='+JSON.stringify(b)
                location.href = encodeURI(url)
              }
            }
          }
        } else {
          if (localStorage.getItem('query')) {
            this.query = JSON.parse(localStorage.getItem('query'))
            this.order_no = this.query.order_sn
            localStorage.removeItem('query')
            let key = '9bwht7zb5rmhv5ygmbicbz8vbmhnvp'
            let headers = utils.getsign(
              {
                order_no: this.order_no
              },
              key
            )
            this.timer = setInterval(async () => {
              let data = await appcheckPay({
                order_no: this.order_no,
                sign: headers['x-sign']
              })
              if (data.error === 0) {
                console.log(data, this.$route.query)
                top.location.href = encodeURI(
                  this.query.merchant_url + this.query?.order_no
                    ? this.query.order_no
                    : ''
                )
              }
            }, 4000)
          } else {
            console.log('3')
            let url =
              localStorage.getItem('returnAddress') +
              'usermy/myOorder?storeId=' +
              a.storeId
            location.href = encodeURI(url)
          }
        }
      }
    },
    backorder () {
      let a = JSON.parse(this.$route.query.a)
      if(a.jumpList==true){
        let url = a.returnAddress + 'usermy/myOorder?storeId=' + a.storeId
        location.href = encodeURI(url)
      }else {
        let url = a.returnAddress + 'usermy/myOorder?storeId=' + a.storeId
        location.href = encodeURI(url)
      }

    },
    // 监听屏幕宽度
    creadersize () {
      // 通过捕获系统的onresize事件触发我们需要执行的事件
      let w = window.innerWidth
      let a = false
      if (w > 767) {
        a = false
      } else {
        a = true
      }
      this.abox = a
    },
    //  间隔两面查询订单支付状态
    async inquireState () {
      let a = JSON.parse(this.$route.query.a)
      if(a.foodOrder){
        console.log('第一步');
        
        if(a.type=='2'){
          let b = {
            type:1,
            orderNo: this.wxdata.orderNo
          }
          console.log('第二步',this.wxdata);
          this.timer = setInterval(async () => {
            let data = await cateringOrderCheck(b)
            if (data.code === 200) {
              let url = a.returnAddress + 'orderFood?storeId='+a.storeId
              location.href = encodeURI(url)
            }
          }, 4000)
        }
      }else if (a.type === '1') {
        if (this.abox === false) {
          let b = {
            type: '1',
            orderNo: a.orderNo,
            payeeSettingId: a.payeeSettingId,
            userId: a.userId,
            storeId: a.storeId
          }
          this.timer = setInterval(async () => {
            let data = await checkPay(b)
            if (data.code === 200) {
              let url = a.returnAddress + 'Successhtml?value=true'+'&b='+JSON.stringify(b)+'&storeId='+a.storeId
              location.href = encodeURI(url)
            }
          }, 4000)
        } else {
          let b = {
            type: '1',
            orderNo: a.orderNo,
            payeeSettingId: a.payeeSettingId,
            userId: a.userId,
            storeId: a.storeId
          }
          this.timer = setInterval(async () => {
            let data = await checkPay(b)
            if (data.code === 200) {
              // console.log(data)
              let url = a.returnAddress + 'Successhtml?value=true'+'&b='+JSON.stringify(b)+'&storeId='+a.storeId
              console.log(data, url)
              location.href = encodeURI(url)
            }
          }, 4000)
        }
      } else if (a.type === 2) {
        let b = {
          type: '0',
          orderNo: a.orderNo,
          payeeSettingId: a.payeeSettingId,
          userId: a.userId,
          storeId: a.storeId
        }
        this.timer = setInterval(async () => {
          let data = await checkPay(b)
          if (data.code === 200) {
            let url = a.returnAddress + 'Successhtml?value=true'+'&b='+JSON.stringify(b)+'&storeId='+a.storeId
            location.href = encodeURI(url)
          }
        }, 1000)
      } else if (a.type === '6') {
        let b = {
          type: '4',
          orderNo: a.orderNo,
          payeeSettingId: a.payeeSettingId,
          userId: a.userId,
          storeId: a.storeId
        }
        this.timer = setInterval(async () => {
          let data = await checkPay(b)
          if (data.code === 200) {
            let url = a.returnAddress + 'Successhtml?value=true'+'&b='+JSON.stringify(b)+'&storeId='+a.storeId
            console.log(data, url)
            location.href = encodeURI(url)
          }
        }, 4000)
      }
    },
    getQRcode (data) {
      this.creadersize()
      if (this.abox === false) {
        new Qrcode(this.$refs.qrcode, {
          // text 需要转二维码的内容 可以是文本也可以是一个链接 是链接会直接跳走
          text: data,
          width: 200,
          height: 200,
          colorDark: '#333', //二维码颜色
          colorLight: '#fff', //二维码背景颜色
          correctLevel: Qrcode.CorrectLevel.L //容错率,L/M/H
        })
      } else {
        new Qrcode(this.$refs.qrcode, {
          // text 需要转二维码的内容 可以是文本也可以是一个链接 是链接会直接跳走
          text: data,
          width: 300,
          height: 300,
          colorDark: '#333', //二维码颜色
          colorLight: '#fff', //二维码背景颜色
          correctLevel: Qrcode.CorrectLevel.L //容错率,L/M/H
        })
      }
    },
    // 初始化获取订单打开支付
    async creaderdata () {
      console.log('=== creaderdata方法开始执行 ===')
      let a = JSON.parse(this.$route.query.a)
      console.log('解析的a参数:', a)
      if (a && a.bizType === 'phoneRecharge') {
        localStorage.setItem('returnAddress', a.returnAddress || '')
        localStorage.setItem('storeID', String(a.storeId || ''))
        if (a.token) settoken(a.token)
        const params = {
          storeId: a.storeId != null && a.storeId !== '' ? Number(a.storeId) : undefined,
          orderNo: a.orderNo || '',
          payType: a.payType != null && a.payType !== '' ? Number(a.payType) : undefined,
          paySettingId: a.paySettingId != null && a.paySettingId !== '' ? Number(a.paySettingId) : undefined
        }
        if (a.remark != null && String(a.remark).trim()) {
          params.remark = String(a.remark).trim()
        }
        const { data } = await payPhoneRechargeConsume(params)
        if (a.isWx && data) {
          this.onBridgeReady(data)
          return
        }
        const payUrl = (data && (data.payUrl || data.pay_url || data.result || data.url)) || ''
        if (payUrl) {
          top.location.href = encodeURI(String(payUrl))
          return
        }
        const redirectBase = String(a.returnAddress || '').trim()
        if (redirectBase) {
          // top.location.href = encodeURI(redirectBase)
          return
        }
        // top.location.href = encodeURI('/s/phoneBill/orderList')
        return
      }
      localStorage.setItem('returnAddress', a.returnAddress)
      localStorage.setItem('storeID', a.storeId)
      settoken(a.token)
      this.letc = a.type
      this.creadersize()
      console.log('支付接口调用')
      console.log('abox值:', this.abox, 'payMethod:', a.payMethod, 'foodOrder:', a.foodOrder)
      if (this.abox === true) {
        if (a.payMethod == 1) {
          console.log('进入payMethod == 1分支')
          let data1 = {
            orderNo: a.orderNo,
            type: '4',
            payeeSettingId: a.payeeSettingId,
            userId: a.userId,
            storeId: a.storeId,
            flag:a.flag
          }
        if(a.foodOrder){
          console.log('进入foodOrder分支，data1:', data1);
          data1.type = '4'
          try {
            console.log('准备调用cateringOrderPlaceAnOrder，参数:', data1);
            let { data } = await cateringOrderPlaceAnOrder(data1)
            console.log('到达这里了',data);
            
            if (data) {
              this.wxdata = data
              if(data.result){
                location.href = data.result
              }else {
                // location.href = data.h5_url
              }
            } else {
              console.log('data为空或undefined');
            }
          } catch (error) {
            console.error('cateringOrderPlaceAnOrder调用出错:', error);
            console.error('错误详情:', error.message, error.stack);
          }
        }else{
          let { data } = await placeAnOrder(data1)
          if (data) {
            this.wxdata = data
            if(data.result){
              location.href = data.result
            }else {
              // location.href = data.h5_url
            }
          }
    
        }
        } else if (a.payMethod === 4) {
          let data1 = {
            orderNo: a.orderNo,
            type: '6',
            payeeSettingId: a.payeeSettingId,
            userId: a.userId,
            storeId: localStorage.getItem('storeID'),
            flag:a.flag
          }
          let { data } = await placeAnOrder(data1)
          if (data) {
            location.href = data.qr_url || data.qr_code
          }
          console.log(data.qr_url || data.qr_code)
          // location.href = data.qr_code
          console.log(data)
        }
      } else {
        let data1 = {
          orderNo: a.orderNo,
          type: '2',
          payeeSettingId: a.payeeSettingId,
          userId: a.userId,
          storeId: a.storeId,
          flag:a.flag
        }
        let { data } = await placeAnOrder(data1)
        this.getQRcode(data.result?data.result:data.code_url)
        this.wxdata = data
      }
      this.inquireState()
    }
  }
  // beforeDestroy() {
  // 	clearInterval(this.timer);
  // },
}
</script>

<style>
.myHome {
  width: 100%;
  min-height: 910px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
}

.zf {
  width: 800px;
  height: 800px;
  border: 1px solid #c7c6c6;
  display: flex;
  background-color: #fff;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.back {
  cursor: pointer;
  position: absolute;
  width: 65px;
  height: 30px;
  border: 1px solid #6e4faa;
  border-radius: 15px;
  line-height: 30px;
  font-family: 'Microsoft YaHei';
  text-align: center;
  color: #6e4faa;
  font-weight: 600;
  left: 10px;
  top: 10px;
}

.wphtitle {
  margin-top: 30px;
}

.Yz {
  margin-top: 20px;
  font-size: 30px;
  font-family: 'Microsoft YaHei';
  font-weight: normal;
  color: #ff4545;
}

.jydh {
  margin-top: 20px;
  color: rgb(189, 189, 189);
}
</style>
